/** A coluna Plataformas da lista de usuários (02/11/2026): um chip por hub em que a
 *  pessoa entra e o selo Superusuário, para ver de longe quem anda nos dois. Aparece
 *  igual no HubTransGrãos e na Administração da Farm, porque a lista é a mesma. O
 *  usuário de cliente aparece com o chip Cliente, como na antiga coluna Tipo. */
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import { ShieldCheck, Store } from 'lucide-react'
import { HUBS } from '../../core/hubs/hubs'
import type { Usuario } from '../../core/api/types'
import { StatusChip } from '../../shared/components/StatusChip'
import { useI18n } from '@/core/i18n/useI18n'
import { Info } from '../dp/comum/lista'
import { plataformasDoUsuario } from './plataformas'

export function ChipDaPlataforma({ nome }: { nome: string }) {
  return (
    <Chip size="small" variant="outlined" label={nome}
      sx={{ height: 22, fontWeight: 600, fontSize: '0.75rem', borderColor: 'divider', '& .MuiChip-label': { px: 1 } }} />
  )
}

export function PlataformasDoUsuario({ usuario }: { usuario: Usuario }) {
  const { t } = useI18n()
  const p = plataformasDoUsuario(usuario)
  // O cliente mantém o chip da antiga coluna Tipo: ele usa o portal, não um hub.
  if (p.cliente) return <StatusChip label={t('usuarios.plataformas.cliente')} tone="info" />
  if (p.hubs.length === 0) return <Info icone={Store} cor="text.disabled">{t('usuarios.plataformas.nenhuma')}</Info>
  return (
    <Box sx={{ display: 'grid', gap: 0.5, justifyItems: 'start' }}>
      {p.superusuario && (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, color: 'primary.main' }}>
          <ShieldCheck size={14} />
          <StatusChip label={t('usuarios.plataformas.superusuario')} tone="primary" />
        </Box>
      )}
      {HUBS.filter((h) => p.hubs.includes(h.key)).map((h) => <ChipDaPlataforma key={h.key} nome={h.nome} />)}
    </Box>
  )
}
